import { useEffect, useState } from 'react';
import { logUserAction, debounce, getSessionId } from '../utility/commonFunctions';

const sessionId = getSessionId();
const userId = localStorage.getItem('userId');
const userAgent = navigator.userAgent;

let cachedIp;

export const getIpAddress = async () => {
  if (cachedIp) return cachedIp;
  try {
    const res = await fetch('https://api.ipify.org?format=json');
    const data = await res.json();
    cachedIp = data.ip;
    return cachedIp;
  } catch (e) {
    new Error('getIpAddress error: ' + e);
    return undefined;
  }
};

const isClickable = (el) =>
  ['BUTTON', 'A', 'INPUT', 'TEXTAREA', 'SELECT'].includes(el.tagName) ||
  el.getAttribute('role') === 'button' ||
  el.tabIndex >= 0;

const GlobalActionLogger = () => {
  const [ip, setIp] = useState(undefined);

  useEffect(() => {
    getIpAddress().then(setIp);
  }, []);

  useEffect(() => {
    if (!ip) return; // wait for IP

    const clickHandler = (e) => {
      if (!e || !e.target) return;
      let target = e.target;
      while (target && !isClickable(target)) {
        target = target.parentElement;
      }
      if (target) {
        logUserAction('CHEF_ACTION', {
          tag: target.tagName,
          text: target.innerText || target.value || '',
          id: target.id || '',
          class: target.className || '',
          sessionId,
          userId,
          userAgent,
          ip,
        });
      }
    };

    const submitHandler = (e) => {
      logUserAction('FORM_SUBMIT', {
        formName: e.target.name || '',
        id: e.target.id || '',
        class: e.target.className || '',
        sessionId,
        userId,
        page: window.location.pathname,
        timestamp: new Date().toISOString(),
        ip,
        userAgent,
      });
    };

    const debouncedClickHandler = debounce(clickHandler, 100);
    const debouncedSubmitHandler = debounce(submitHandler, 300);

    document.addEventListener('click', debouncedClickHandler, true);
    document.addEventListener('submit', debouncedSubmitHandler, true);

    return () => {
      document.removeEventListener('click', debouncedClickHandler, true);
      document.removeEventListener('submit', debouncedSubmitHandler, true);
    };
  }, [ip]);

  return null;
};

export default GlobalActionLogger;
